import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, TextBox } from '../../components/imports';
// import useDisplayValue from '../../hooks/useDisplayValue';
// import useMouse from '../../hooks/useMouse';

const Content = () => {

  // const heroRef = useRef(null);
  const landingRef = useRef(null);

  // const { formattingFn } = useDisplayValue("");
  // const { toDefault, toPlay } = useMouse();

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

          {/* <div className='flex flex-col relative items-center justify-center w-full space-y-6 mb-24 -mt-[5%]'>
            <div className='grid grid-cols-3 resp gap-4 max-h-100 *:h-full '>
              <ImageMedia src={require('./assets/ig_profilePic_1.jpg')} />
              <ImageMedia src={require('./assets/ig_profilePic_2.jpg')} />
              <ImageMedia src={require('./assets/ig_profilePic_3.jpg')} />
            </div>
            <TextBox
              title={"Logo Concept"}
              descr={"Abstract symbol, the main logo of Annagram is made of a [A] and a [G] vertically stacked. This lockup expresses Precision, Technology Growth and Connectors path in the negative spaces."}
              className={"resp paddingY"}
            />
            <ImageMedia src={require('./assets/icon.png')} className={" paddingX !object-contain !max-h-100 "} />
          </div> */}


          <MotionContent imgRef={landingRef} height={"height"} className="" refDiv={require('./assets/ylw_bagBlue1.jpg')}>
            <ImageMedia
              key={"yellowBags"}
              src={require('./assets/ylw_bagBlue1.jpg')}
              className="w-full h-full object-contain !object-top"
            />
          </MotionContent>

          <TextBox
            title={"Web Design & Development"}
            descr={`For YELLOW, we built a brand identity and website that feel clear, confident, and easy to connect with. LAWWD shaped the strategy first, defining a visual system that is bold but simple, expressive but structured.\n\nFrom the logo and typography to the digital UI components and motion details, every element was designed to work together and grow with the brand. The website brings this identity to life through a clean, intuitive experience that prioritizes clarity, speed, and real engagement.\n\nThe result is a digital presence that feels strong, modern, and ready to lead.`}
            className={"resp paddingY"}
          />
          <div className='lg:flex lg:flex-row lg:max-h-200 max-lg:grid grid-cols-1 lg:grid-cols-2 w-full relative bg-dark pt-12 gap-4'>

            <ImageMedia
              key={"ylwWeb"}
              src={require('./assets/_cover_web.jpg')}
              className="lg:w-3/5 lg:h-full! lg:object-cover! "
            />
            <div className='relative flex w-full padding'>

              <ImageMedia
                key={"ylwHand"}
                src={require('./assets/ylw_web.jpg')}
                className="lg:w-2/5= lg:h-full"
              />
            </div>

            {/* <ImageMedia
              key={"ylwHand"}
              src={require('./assets/ylw_ringSilver.jpg')}
              className="lg:w-2/5 lg:h-full"
              /> */}
            {/* <MotionContent imgRef={heroRef} height={"lg:h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img" + thisProject.client}
                src={require('./assets/AnimaIris, 14.jpg')}
                className="relative md:landscape:scale-[110%] full object-contain object-center"
              />
            </MotionContent>
            <MotionContent imgRef={heroRef} height={"h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img2" + thisProject.client}
                src={require('./assets/_cover.jpg')}
                className="relative md:landscape:scale-[110%] full object-cover lg:object-contain object-center"
              />
            </MotionContent>*/}
          </div>
          <div className='resp py-20 uppercase flex flex-col items-center justify-center'>
            <h3>to be continued...</h3>
          </div>

        </div>
      )}
    </ThisProject>
  )
}

export default Content